export default __webpack_public_path__ + "static/media/Uphaar.9773d681.png";